import { z } from "zod";

export const MAX_UPLOAD_SIZE_BYTES = 10 * 1024 * 1024;

export const uploadResponseSchema = z.array(z.object({ stagingFileId: z.string() }));
